module.exports = __webpack_public_path__ + "img/collectNot.2e5ad333.svg";